// extracted by mini-css-extract-plugin
export default {"root":"Search_root__eiX89","input":"Search_input__klILD","clear":"Search_clear__q6EIX","search":"Search_search__JtbP4"};